// eslint-disable-next-line
import React, { Component } from 'react';
import { Badge } from 'reactstrap';

export class TableLink extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: '160px',
            height: '27px',
        };
    }

    render() {
        return (
            <Badge
                color="secondary"
                style={{
                    'width': this.state.width,
                    'height': this.state.height,
                    'textAlign': 'center',
                    'verticalAlign': 'middle',
                    'paddingTop': '10px',
                    'cursor': 'pointer'
                }}
                onClick={this.props.onClick}>
                {this.props.text}
            </Badge>
        );
    }
}